class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
      if(this.closest('tr').getAttribute("name") == '44993513750843' ){
        console.log(document.querySelector("#gift-message-wrapper"))
        document.querySelector("#gift-message-wrapper").innerHTML = `
        <gift-note-button>
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-gift" fill="none" viewBox="0 0 512 512">
            <path d="M448 128h-.4043c11.83-15.64 18.37-35.48 15.88-57.12c-2.67-23.17-17.02-43.45-36.28-56.6C357.5-33.31 291.3 48.56 256 106C220.7 48.56 154.5-33.31 84.81 14.28c-19.26 13.15-33.61 33.43-36.28 56.6C46.03 92.52 52.57 112.4 64.4 128H64C28.65 128 0 156.7 0 192v64c0 17.67 14.33 32 32 32L32 448c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64l.0001-160C497.7 288 512 273.7 512 256V192C512 156.7 483.3 128 448 128zM384 32c26.47 0 48 21.53 48 48S410.5 128 384 128h-103.9C315.3 69.01 354.8 32 384 32zM128 32c29.22 0 68.67 37.01 103.9 96H128C101.5 128 80 106.5 80 80S101.5 32 128 32zM32 255.1L32 192c0-17.64 14.36-32 32.4-32H240v95.87L32 255.1zM96 480c-17.67 0-32-14.33-32-32V288h176v192H96zM448 448c0 17.67-14.33 32-32 32h-144V288H448V448zM480 255.1L272 255.9V160H448c17.64 0 32 14.36 32 32L480 255.1z" fill="currentColor"></path>
          </svg>
          Add Gift Note
      </gift-note-button>
        `
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target === null) return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping',
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = cartStrings.error;
        }
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          ); 
      }
    }

    this.currentItemCount = itemCount;
    
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    
    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);
      console.log(element, parsedState.sections[section.id]);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
  }
}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);


class GiftNoteButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', debounce(async (event) => {

      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
  
      if (!cartResponse.ok) {
        throw new Error('Failed to fetch cart data');
      }
  
      const cart = await cartResponse.json();
  
      const cartItems = cart.items;

      const accessories = document.querySelectorAll('.hidden-accessories-item');
      const accessoriesHandles = Array.from(accessories).map(element => element.getAttribute('data-handle'));

      const parentItems = cartItems.filter(item => {
        return !accessoriesHandles.some(accessories => {
            return item.handle === accessories;
        });
      });

      let ParentQuantity = 1;

      if(parentItems){
        ParentQuantity = 0;
        parentItems.forEach(item => {
          ParentQuantity += item.quantity;
        })
      }

      const productData = {
        'id': '44993513750843',
        'quantity': ParentQuantity,
      };
      
      const response = await fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 'items': [productData] }),
      });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }else{
        location.reload();
      }      
    }, 300));
    
  }
}
customElements.define('gift-note-button', GiftNoteButton);

class GiftNoteButtonMini extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', debounce(async (event) => {

      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
  
      if (!cartResponse.ok) {
        throw new Error('Failed to fetch cart data');
      }
  
      const cart = await cartResponse.json();
  
      const cartItems = cart.items;

      const accessories = document.querySelectorAll('.hidden-accessories-item');
      const accessoriesHandles = Array.from(accessories).map(element => element.getAttribute('data-handle'));
      

      const parentItems = cartItems.filter(item => {
        return !accessoriesHandles.some(accessories => {
            return item.handle === accessories;
        });
      });

      let ParentQuantity = 1;

      if(parentItems){
        ParentQuantity = 0;
        parentItems.forEach(item => {
          ParentQuantity += item.quantity;
        })
      }

      
      let messageContainer = event.target.closest('gift-message');
      let message = messageContainer.querySelector('textarea').value;
      const productData = {
        'items': [
          {
            'id': '44993513750843',
            'quantity': ParentQuantity,
            'properties': {
              'Message': `${message}`,
            },
            
          }
        ]
      };
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(productData)
      })
      .then(response => response.json())
      .then(cart => this.RerenderCart(cart))
      .catch(error => console.error(error));
      
    }, 300));   
  }

  RerenderCart = (cart) => {
    let list = document.querySelector(".mini-cart__navigation");
    let total = document.querySelector("#mini-cart-subtotal");
    let cartAction = document.querySelectorAll(".mini-cart__action")[1];
    cartAction.classList.add('disclosure-has-popup"');
    cartAction.removeAttribute('open');
    cartAction.innerHTML = `
    <summary>
      <span>
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-gift" fill="none" viewBox="0 0 512 512">
        <path d="M448 128h-.4043c11.83-15.64 18.37-35.48 15.88-57.12c-2.67-23.17-17.02-43.45-36.28-56.6C357.5-33.31 291.3 48.56 256 106C220.7 48.56 154.5-33.31 84.81 14.28c-19.26 13.15-33.61 33.43-36.28 56.6C46.03 92.52 52.57 112.4 64.4 128H64C28.65 128 0 156.7 0 192v64c0 17.67 14.33 32 32 32L32 448c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64l.0001-160C497.7 288 512 273.7 512 256V192C512 156.7 483.3 128 448 128zM384 32c26.47 0 48 21.53 48 48S410.5 128 384 128h-103.9C315.3 69.01 354.8 32 384 32zM128 32c29.22 0 68.67 37.01 103.9 96H128C101.5 128 80 106.5 80 80S101.5 32 128 32zM32 255.1L32 192c0-17.64 14.36-32 32.4-32H240v95.87L32 255.1zM96 480c-17.67 0-32-14.33-32-32V288h176v192H96zM448 448c0 17.67-14.33 32-32 32h-144V288H448V448zM480 255.1L272 255.9V160H448c17.64 0 32 14.36 32 32L480 255.1z" fill="currentColor"/>
      </svg>
      Gift Note    
      </span>
    </summary>
    <div>
      <button type="button" class="close" onclick="this.closest('details').querySelector('summary').click()">
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
          <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/>
        </svg>
      </button>
      <label for="Cart-note">Gift note</label>
      <gift-message class="mini-cart__note">
        <div class="field">
          <textarea
            class="text-area text-area--resize-vertical field__input"
            name="attributes[gift_message]"
            id="Gift-message"
            placeholder="gift message"
          >${cart.items[0].properties.Message}</textarea>                
        </div>
        <div>
          <gift-note-updated class="button button--full-width" type="button" onclick="this.closest('details').querySelector('summary').click()">Apply</gift-note-updated>
        </div>
      </gift-message>
    </div>
    `
    let totalPrice = parseInt(total.innerHTML.replace(/\D/g,'')) + cart.items[0].price;
    total.innerHTML = `$${totalPrice / 100}.00 USD`
    list.insertAdjacentHTML('afterbegin',`
      <li data-variant-id="44993513750843" data-handle="gift-note" data-quantity="1" data-price="${cart.items[0].price}">
          <div class="loading-overlay hidden">
            <div class="loading-overlay__spinner">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" fill="none" viewBox="0 0 66 66">
    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
  </svg>
            </div>
          </div>
          <cart-remove-button id="Remove-1" data-index="1">
            <a href="/cart/change?id=44993513750843:16f91c2d0810215c9a276ebf5e21f9d3&amp;quantity=0" class="delete-product" aria-label="Remove Gift Note" data-no-instant="">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close " fill="none" viewBox="0 0 12 12">
    <path d="M1 1L11 11" stroke="currentColor" stroke-linecap="round" fill="none"></path>
    <path d="M11 1L1 11" stroke="currentColor" stroke-linecap="round" fill="none"></path>
  </svg>
            </a>
          </cart-remove-button>
          <div class="product-container">
            
              <div>
                <a href="/products/gift-note?variant=44993513750843" class="product-image media-wrapper media-wrapper--small">
                  <lazy-image class="media media--adapt" style="--image-ratio-percent: 100.0%;">
                    <img srcset="${cart.items[0].image}" alt="" width="70" height="70" loading="lazy">
                  </lazy-image>
                </a>
              </div>
            
            <div class="product-description">
              <div class="product-content">
                <a href="${cart.items[0].url}" class="link product-title">Gift Note</a>
                <p class="cart-item__error form__message errors" id="Line-item-error-1">
                  <span class="cart-item__error-text"></span>
                </p>
              </div><dl>
              <div class="product-option">
                        <dt>Message: </dt>
                        <dd>${cart.items[0].properties.Message}
                        </dd>
                      </div>
              </dl><div class="product-quantity">
                <dt><label for="Quantity-1" class="visually-hidden">Quantity</label>
                    <quantity-input class="quantity">
                      <button class="quantity__button no-js-hidden" name="minus" type="button">
                        <span class="visually-hidden">Decrease quantity for Gift Note</span>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
  </svg>
                      </button>
                      <input class="quantity__input" type="number" name="updates[]" value="${cart.items[0].quantity}" min="0" aria-label="Quantity for Gift Note" id="Quantity-1" data-index="1">
                      <button class="quantity__button no-js-hidden" name="plus" type="button">
                        <span class="visually-hidden">Increase quantity for Gift Note</span>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
  </svg>
                      </button>
                    </quantity-input></dt>
                <dd class="price">
                  <price-money><bdi><span class="price__prefix">$</span>0<sup class="price__suffix">${parseInt(cart.items[0].final_price / 100)}.00</sup></bdi></price-money>
                </dd>
              </div>
            </div>
          </div>
        </li>
    `);
    console.log(list)
  }
}
customElements.define('gift-note-button-mini', GiftNoteButtonMini);


class GiftNoteUpdate extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', debounce(async (event) => {

      const variantId = '44993513750843';

      fetch(`/cart/change.js?id=${variantId}&quantity=0`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(cart => {
        if(window.location.pathname != '/cart'){
          this.RemoveGiftMessage()
        }
        setTimeout(() => {
          this.AddGift(event);
        },400)
      })
      .catch(error => console.error(error));
      
    }, 300));   
  }

  AddGift = async (event) => {

    const cartResponse = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart data');
    }

    const cart = await cartResponse.json();

    const cartItems = cart.items;

    const accessories = document.querySelectorAll('.hidden-accessories-item');
    const accessoriesHandles = Array.from(accessories).map(element => element.getAttribute('data-handle'));
    

    const parentItems = cartItems.filter(item => {
      return !accessoriesHandles.some(accessories => {
          return item.handle === accessories;
      });
    });

    let ParentQuantity = 1;

    if(parentItems){
      ParentQuantity = 0;
      parentItems.forEach(item => {
        ParentQuantity += item.quantity;
      })
    }
    
    let messageContainer = document.querySelector('gift-message');
    let message = messageContainer.querySelector('textarea').value;
    const productData = {
      'items': [
        {
          'id': '44993513750843',
          'quantity': ParentQuantity,
          'properties': {
            'Message': `${message}`,
          },
          
        }
      ]
    };
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(productData)
    })
    .then(response => response.json())
    .then(cart => {
      if(window.location.pathname != '/cart'){
        this.RerenderCart(cart)
      }else{
        location.reload();
      }
    })
    .catch(error => console.error(error));
  }

  RemoveGiftMessage = () => {
    let list = document.querySelector(".mini-cart__navigation");
    const divToRemove = list.querySelector(`[data-variant-id="44993513750843"]`);
    divToRemove.remove();
  }

  RerenderCart = (cart) => {
    let list = document.querySelector(".mini-cart__navigation");
    let total = document.querySelector("#mini-cart-subtotal");
    let cartAction = document.querySelectorAll(".mini-cart__action")[1];
    cartAction.classList.add('disclosure-has-popup"');
    cartAction.removeAttribute('open');
    cartAction.innerHTML = `
    <summary>
      <span>
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-gift" fill="none" viewBox="0 0 512 512">
        <path d="M448 128h-.4043c11.83-15.64 18.37-35.48 15.88-57.12c-2.67-23.17-17.02-43.45-36.28-56.6C357.5-33.31 291.3 48.56 256 106C220.7 48.56 154.5-33.31 84.81 14.28c-19.26 13.15-33.61 33.43-36.28 56.6C46.03 92.52 52.57 112.4 64.4 128H64C28.65 128 0 156.7 0 192v64c0 17.67 14.33 32 32 32L32 448c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64l.0001-160C497.7 288 512 273.7 512 256V192C512 156.7 483.3 128 448 128zM384 32c26.47 0 48 21.53 48 48S410.5 128 384 128h-103.9C315.3 69.01 354.8 32 384 32zM128 32c29.22 0 68.67 37.01 103.9 96H128C101.5 128 80 106.5 80 80S101.5 32 128 32zM32 255.1L32 192c0-17.64 14.36-32 32.4-32H240v95.87L32 255.1zM96 480c-17.67 0-32-14.33-32-32V288h176v192H96zM448 448c0 17.67-14.33 32-32 32h-144V288H448V448zM480 255.1L272 255.9V160H448c17.64 0 32 14.36 32 32L480 255.1z" fill="currentColor"/>
      </svg>
      Gift Note    
      </span>
    </summary>
    <div>
      <button type="button" class="close" onclick="this.closest('details').querySelector('summary').click()">
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
          <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/>
        </svg>
      </button>
      <label for="Cart-note">Gift note</label>
      <gift-message class="mini-cart__note">
        <div class="field">
          <textarea
            class="text-area text-area--resize-vertical field__input"
            name="attributes[gift_message]"
            id="Gift-message"
            placeholder="gift message"
          >${cart.items[0].properties.Message}</textarea>                
        </div>
        <div>
          <gift-note-updated class="button button--full-width" type="button" onclick="this.closest('details').querySelector('summary').click()">Apply</gift-note-updated>
        </div>
      </gift-message>
    </div>
    `
    let totalPrice = parseInt(total.innerHTML.replace(/\D/g,'')) + cart.items[0].price;
    total.innerHTML = `$${totalPrice / 100}.00 USD`
    console.log(cart.items[0])
        list.innerHTML = list.innerHTML + (`
          <li data-variant-id="44993513750843" data-handle="gift-note" data-quantity="1" data-price="${cart.items[0].price}">
              <div class="loading-overlay hidden">
                <div class="loading-overlay__spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" fill="none" viewBox="0 0 66 66">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
                </div>
              </div>
              <cart-remove-button id="Remove-1" data-index="1">
                <a href="/cart/change?id=44993513750843:16f91c2d0810215c9a276ebf5e21f9d3&amp;quantity=0" class="delete-product" aria-label="Remove Gift Note" data-no-instant="">
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close " fill="none" viewBox="0 0 12 12">
        <path d="M1 1L11 11" stroke="currentColor" stroke-linecap="round" fill="none"></path>
        <path d="M11 1L1 11" stroke="currentColor" stroke-linecap="round" fill="none"></path>
      </svg>
                </a>
              </cart-remove-button>
              <div class="product-container">
                
                  <div>
                    <a href="/products/gift-note?variant=44993513750843" class="product-image media-wrapper media-wrapper--small">
                      <lazy-image class="media media--adapt" style="--image-ratio-percent: 100.0%;">
                        <img srcset="${cart.items[0].image}" alt="" width="70" height="70" loading="lazy">
                      </lazy-image>
                    </a>
                  </div>
                
                <div class="product-description">
                  <div class="product-content">
                    <a href="${cart.items[0].url}" class="link product-title">Gift Note</a>
                    <p class="cart-item__error form__message errors" id="Line-item-error-1">
                      <span class="cart-item__error-text"></span>
                    </p>
                  </div><dl>
                  <div class="product-option">
                            <dt>Message: </dt>
                            <dd>${cart.items[0].properties.Message}
                            </dd>
                          </div>
                  </dl><div class="product-quantity">
                    <dt><label for="Quantity-1" class="visually-hidden">Quantity</label>
                        <quantity-input class="quantity">
                          <button class="quantity__button no-js-hidden" name="minus" type="button">
                            <span class="visually-hidden">Decrease quantity for Gift Note</span>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
      </svg>
                          </button>
                          <input class="quantity__input" type="number" name="updates[]" value="${ cart.items[0].quantity}" min="0" aria-label="Quantity for Gift Note" id="Quantity-1" data-index="1">
                          <button class="quantity__button no-js-hidden" name="plus" type="button">
                            <span class="visually-hidden">Increase quantity for Gift Note</span>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
      </svg>
                          </button>
                        </quantity-input></dt>
                    <dd class="price">
                      <price-money><bdi><span class="price__prefix">$</span>0<sup class="price__suffix">${parseInt(cart.items[0].final_price / 100)}.00</sup></bdi></price-money>
                    </dd>
                  </div>
                </div>
              </div>
            </li>
        `);
  }
  
}
customElements.define('gift-note-updated', GiftNoteUpdate);


class GiftMessage extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');

    // this.addEventListener('change', debounce((event) => {
    //   const body = JSON.stringify({ attributes: { gift_note: event.target.value } });
    //   fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    // }, 300));
  }
}
customElements.define('gift-message', GiftMessage);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);

$( "#cart" ).submit(function( event ) {
  let price = Number(document.querySelector(".totals__subtotal-value").innerHTML.split(" ")[0].replace("$", ""));
  let customized = false;
  if(localStorage.getItem("CustomizedFlag") == "true" || localStorage.getItem("ArtFileFlag") == "true"){
    customized = true;
  }

  let errorTextPlacement = document.querySelector("#cart-errors");
  if(customized && ( price < orderMinimumCustomization )){
    event.preventDefault();
    errorTextPlacement.textContent = `Order minimum amount is $${orderMinimumCustomization} USD`;
  }
  if(!(customized) && ( price < orderMinimum)){
    event.preventDefault();
    errorTextPlacement.textContent = `Order minimum amount is $${orderMinimum} USD`;
  }
});